import React, { useEffect, useState } from 'react';
import api from '../../Api/api';
import MainBar from '../../Components/MainBar/MainBar';
import { Switch, Link, Redirect } from 'react-router-dom';
import {
  Layout,
  Menu,
  Icon,
  Row,
  Col,
  Card,
  Typography,
  Button,
  Input,
} from 'antd';
import TimeSheet from '../TimeSheet/TimeSheet';
import UserProjects from '../UserProjects';
import AdminCalendar from '../AdminCalendar/AdminCalendar';
import PrivateRoute from '../../Components/PrivateRoute/PrivateRoute';
import { useAuth0 } from '../../react-auth0-spa';
import style from './style.module.css';
import companySVG from './revenue-graph-monochrome.svg';
import userSVG from './drawkit-notebook-man-monochrome.svg';
import { useDispatch } from 'react-redux';
import { REQUEST_GET_AUTH_USER_DATA } from '../../Redux/constants/constants';

const { Header, Footer } = Layout;
const { Title } = Typography;

const Starter = () => {
  const { user } = useAuth0();
  const dispatch = useDispatch();
  const [localData, setLocalData] = useState({});
  const [loading, setLoading] = useState(false);

  const onChange = (value, key) => {
    setLocalData({ ...localData, [key]: value });
  };

  const handleSave = () => {
    setLoading(true);
    api.createCompany(localData).then(() => {
      setLoading(false);
      setLocalData({});
    });
  };

  useEffect(() => {
    if (user) {
      dispatch({
        type: REQUEST_GET_AUTH_USER_DATA,
        payload: user.email,
      });
    }
  }, [loading]);

  return (
    <>
      <Layout style={{ minHeight: '100vh' }}>
        <Layout>
          <Header
            style={{
              background: '#fff',
              boxShadow: '0 1px 4px 0 rgba(0,21,41,.08)',
              padding: 0,
              zIndex: 99,
            }}
          >
            <MainBar />
          </Header>
          <Row
            type="flex"
            justify="center"
            style={{ minHeight: '40px', marginTop: '60px' }}
          >
            <Title level={2}>Zacznij korzystać z Time Cube jako:</Title>
          </Row>
          <Row type="flex" justify="center" style={{ minHeight: '100px' }}>
            <Col xs={22} md={10} xl={6}>
              <Card
                title={<div style={{ textAlign: 'center' }}>Firma</div>}
                bordered={false}
                style={{
                  marginTop: '48px',
                  marginRight: '8px',
                  width: 'auto',
                  borderRadius: '6px',
                  minHeight: '700px',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    height: '400px',
                  }}
                >
                  <img alt="company" src={companySVG} height="320" />
                </div>
                <div style={{ marginBottom: '24px' }}>
                  Jestem administratorem lub właścicielem firmy. Chcę założyć
                  konto dla mojej organizacji.
                </div>
                <div className={style.inputWrapper}>
                  <Input
                    placeholder="nazwa firmy"
                    value={localData.companyName}
                    onChange={(e) => onChange(e.target.value, 'companyName')}
                  />
                </div>
                <div className={style.inputWrapper}>
                  <Input
                    placeholder="imię i nazwisko"
                    value={localData.userName}
                    onChange={(e) => onChange(e.target.value, 'userName')}
                  />
                </div>
                <Button type="primary" onClick={handleSave}>
                  Załóż
                </Button>
              </Card>
            </Col>
            <Col xs={22} md={10} xl={6}>
              <Card
                title={<div style={{ textAlign: 'center' }}>Pracownik</div>}
                bordered={false}
                style={{
                  marginTop: '48px',
                  marginLeft: '8px',
                  width: 'auto',
                  borderRadius: '6px',
                  minHeight: '700px',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    height: '400px',
                  }}
                >
                  <img alt="company" src={userSVG} height="320" />
                </div>
                Twój profil nie został jeszcze utworzony. Poproś swojego
                administratora o dodanie Twojego adresu email (
                <strong>{`${user.email}`}</strong>) do Time Cube.
              </Card>
            </Col>
          </Row>
          <Switch>
            <PrivateRoute path="/user/timesheet" component={TimeSheet} />
            <PrivateRoute path="/user/projects" component={UserProjects} />
            <PrivateRoute path="/user/calendar" component={AdminCalendar} />
            {/*  change to user calendar after introducing changes to admin/user calendar*/}
          </Switch>
          <Footer style={{ textAlign: 'center' }}>Time Cube, 2020</Footer>
        </Layout>
      </Layout>
    </>
  );
};

export default Starter;
